// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stall-aerodynamics.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stall-aerodynamics/stall-aerodynamics.js';

mount([g0]);
